export const TEACHING_SCOPES = {
  IN_MODULE: "IN_MODULE",
};
